import React from "react";
import { Link, Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import {
  EmployeeDetailLayout,
  EmployeeInfo,
  EmployeeTeam,
} from "./components/EmployeeDetailLayout";
import { EmployeeListLayout } from "./components/EmployeeListLayout";
import { EmployeeInactiveList } from "./components/EmployeeInactiveList";
import { EmployeeActiveList } from "./components/EmployeeActiveList";
import { EmployeeAreaList } from "./components/EmployeeAreaList";
import { EmployeeHistoryList } from "./components/EmployeeHistoryList";
import { EmployeeManagerList } from "./components/EmployeeManagerList";
import { EmployeePositionList } from "./components/EmployeePositionList";
import { EmployeeTeamList } from "./components/EmployeeTeamList";
import { EmployeeSecondaryTeamList } from "./components/EmployeeSecondaryTeamList";
import { EmployeeCreateScreen } from "./components/CreateEmployee/EmployeeCreateScreen";
import { OrgChart } from "./components/OrganogramChart/OrgChart";
import { EditEmployeeScreen } from "./components/EditEmployee";
import { useSettingValue } from "../utils/Hooks";
import { EmployeePositionTasks } from "../../src/employee_tasks/components/EmployeeTasks";
export const LinkEmployee = ({ employee, children }) => {
  if (!employee) return null;

  return (
    <Link to={`/funcionarios/${employee.id}`}>{children || employee.name}</Link>
  );
};

export const EmployeeRoutes = () => {
  const { path } = useRouteMatch();
  const isEditEmployeeScreenEnabled = useSettingValue(
    "T005_EMPLOYEE_EDITING_SCREEN_ENABLED",
  );

  return (
    <Switch>
      <Route path={`${path}/create_employee`}>
        <EmployeeCreateScreen />
      </Route>
      {isEditEmployeeScreenEnabled && (
        <Route path={`${path}/edit_employee/:employee_id`}>
          <EditEmployeeScreen />
        </Route>
      )}
      <Route path={`${path}/:employee_id(\\d+)`}>
        <EmployeeDetailLayout />
      </Route>
      <Route path={path}>
        <EmployeeListLayout />
      </Route>
    </Switch>
  );
};

export const EmployeeStartRoutes = ({ employee_id }) => {
  let { url, path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/time`}>
        <EmployeeTeam employee_id={employee_id} />
      </Route>
      <Route path={`${path}/info`}>
        <EmployeeInfo employee_id={employee_id} />
      </Route>
      <Redirect to={`${url}/info`} employee_id={employee_id} />
    </Switch>
  );
};

export const EmployeeDetailRoutes = ({ employee_id }) => {
  let { url, path } = useRouteMatch();
  const isEmployeePositionTasksEnabled = useSettingValue(
    "T012_EMPLOYEE_POSITION_TASKS_ENABLED",
  );

  return (
    <Switch>
      <Route path={`${path}/historico`}>
        <EmployeeHistoryList employee_id={employee_id} />
      </Route>
      <Route path={`${path}/areas`}>
        <EmployeeAreaList employee_id={employee_id} />
      </Route>
      {isEmployeePositionTasksEnabled && (
        <Route path={`${path}/tarefas_funcao`}>
          <EmployeePositionTasks employeeId={employee_id} />
        </Route>
      )}
      <Route path={`${path}/cargos`}>
        <EmployeePositionList employee_id={employee_id} />
      </Route>
      <Route path={`${path}/gestores`}>
        <EmployeeManagerList employee_id={employee_id} />
      </Route>
      <Redirect to={`${url}/gestores`} employee_id={employee_id} />
    </Switch>
  );
};

export const EmployeeTeamRoutes = ({ employee_id }) => {
  let { url, path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/liderados`}>
        <EmployeeTeamList employee_id={employee_id} />
      </Route>
      <Route path={`${path}/organograma`}>
        <OrgChart employee_id={employee_id} />
      </Route>
      <Route path={`${path}/secundario`}>
        <EmployeeSecondaryTeamList employee_id={employee_id} />
      </Route>
      <Redirect to={`${url}/liderados`} employee_id={employee_id} />
    </Switch>
  );
};

export function EmployeeListRoutes({ search, activeData }) {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/inativos`}>
        <EmployeeInactiveList search={search} />
      </Route>
      <Route path={path}>
        <EmployeeActiveList activeData={activeData} />
      </Route>
    </Switch>
  );
}
